import React, { useState } from "react";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import CardMemberGrid from "../../atoms/card-member-grid/cardMemberGrid";
import Paginator from "../../atoms/paginator/paginator";
import Button from "../../atoms/button/button";

import "./memberGrid.scss";

const MemberGrid = (props: ReferenciaContenido) => {
  const [initialValue, setInitialValue] = useState(0);
  const [lastValue, setLastValue] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [showMobile, setShowMobile] = useState(5);

  const members = props.referenciaPlantillaContenido;

  return (
    <div className="o-member-grid">
      <h2 className="o-member-grid__title">{props.tituloGeneral}</h2>

      <div className="o-member-grid__desk hide-on-mobile">
        <div className="o-member-grid__desk-pags">
          {members.filter(member => member.imagenPrincipal).slice(initialValue * 10, lastValue * 10).map((elem, idx) => {
            return (
              <div key={idx} className="o-member-grid__desk-pags-child">
                <CardMemberGrid member={elem} key={idx} />
              </div>
            );
          })}
        </div>

        <div className="o-member-grid__desk-paginator">
          {props.referenciaPlantillaContenido.length > 10 && (
            <Paginator
              arrLength={props.referenciaPlantillaContenido.length}
              initialValue={initialValue}
              lastValue={lastValue}
              setInitialValueH={setInitialValue}
              setLastValue={setLastValue}
              currentValue={currentPage}
              setCurrentValue={setCurrentPage}
            />
          )}
        </div>
      </div>

      <div className="o-member-grid__mobile show-on-mobile">
        <div className="o-member-grid__mobile-cards">
          {members.filter(member => member.imagenPrincipal).slice(0, showMobile).map((elem, idx) => {
            return <CardMemberGrid member={elem} key={idx} />;
          })}
        </div>

        <div
          className="o-member-grid__mobile-button"
          style={{
            display: members.length >= showMobile ? "flex" : "none",
          }}
        >
          <Button
            type="button"
            classname="o-member-grid__mobile-button-btn"
            text="VER MÁS"
            isDisabled={false}
            onClickAction={() => setShowMobile(showMobile + 5)}
          />
        </div>
      </div>
    </div>
  );
};

export default MemberGrid;
